<template>
  <div>
    <embedded-header></embedded-header>
    <div class="container mt-5 text-center form-signin">
      <h4 class="mb-3 font-weight-normal">
          Welcome back! Please log in first!
      </h4>
      <form
        @submit="login($event)"
        action="/dontcare"
        class="row-container"
        method="post">

      <div class="input-group mb-3 required">
        <div class="input-group-prepend">
          <label class="input-group-text" for="username">User name:</label>
        </div>
        <input
            v-model="username"
            id="username"
            name="username"
            type="text"
            class="form-control"
        />
      </div>
      <div class="input-group mb-3 required">
        <div class="input-group-prepend">
          <label class="input-group-text" for="password">Password:</label>
        </div>
        <input
            v-model="password"
            id="password"
            name="password"
            type="password"
            class="form-control"
        />
      </div>

      <div class="row pt-1">
        <div class="col-12">
          <button class="float-right btn btn-cta btn-lg btn-cta-large btn-block" type="submit">Log in</button>
        </div>
      </div>
      </form>
    </div>
  </div>
</template>

<script>
import EmbeddedHeader from "@/components/EmbeddedHeader";
import BackendClient from "@/rest/backend-client";
export default {
  name: "EmbeddedLogin",
  head: {
    title: 'just bookmark it! - login'
  },
  components: {EmbeddedHeader},
  data() {
    return {
      username: "",
      password: "",
      backendClient: new BackendClient(),
      hasError: false
    }
  },
  methods: {
    login(event) {
      event.preventDefault();
      if (this.username === "" || this.password === "") {
        this.$store.commit("addError", "Empty username or password!");
        return;
      }
      this.backendClient.login(this.username, this.password).then(() => {
        this.$router.replace(this.$route.query.prevUrl);
      });
    }
  }
}
</script>

<style scoped>
.input-group-text {
  width: 8em;
}

.form-signin {
  max-width: 390px;
}
</style>